module.exports = __webpack_public_path__ + "img/2-5.d3a67120.svg";